import { render, staticRenderFns } from "./menu_tree_table.vue?vue&type=template&id=31d82814&scoped=true"
import script from "./menu_tree_table.vue?vue&type=script&lang=js"
export * from "./menu_tree_table.vue?vue&type=script&lang=js"
import style0 from "./menu_tree_table.vue?vue&type=style&index=0&id=31d82814&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d82814",
  null
  
)

export default component.exports